// extracted by mini-css-extract-plugin
module.exports = {"modalSpinner":"az_Cs","dialog":"az_Ds"};